'use client'

import { useTranslations } from 'next-intl'
import { useRef, useState } from 'react'

import ViverseButton from '@/components/ViverseButton'
import ViverseInputOTP from '@/components/ViverseInputOTP'
import { redirectAfterPasscodeValidation } from '@/server/lib/passcode'

const PASSCODE_LENGTH = 6

interface SpacePasscodeProps {
  roomId: string
  roomTitle?: string
  htcAuthKey?: string
}

export default function SpacePasscode({
  roomId,
  roomTitle = '',
  htcAuthKey = '',
}: SpacePasscodeProps) {
  const t = useTranslations()

  const [passcode, setPasscode] = useState<string>('')
  const [hasError, setHasError] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const handlePasscode = async (formData: FormData) => {
    const code = formData.get('passcode')?.toString() ?? ''
    const isInvalid = await redirectAfterPasscodeValidation(code, roomId, htcAuthKey)
    if (!isInvalid) {
      setPasscode('')
      setHasError(true)
      inputRef.current?.focus()
    }
  }

  return (
    <form
      action={handlePasscode}
      className="flex h-svh w-full flex-col items-center justify-center text-base"
    >
      <h2 className="mb-2 text-lg text-gray-300">{t('space-passcode-page.intro-topic')}</h2>
      <p className="mb-2 text-xl font-bold text-white">{roomTitle}</p>
      <p className="mb-8 max-w-md text-xs text-gray-400">{t('space-passcode-page.intro-desc')}</p>

      <div className="mb-10">
        <ViverseInputOTP
          ref={inputRef}
          name="passcode"
          maxLength={PASSCODE_LENGTH}
          value={passcode}
          onChange={setPasscode}
          hasError={hasError}
          defaultHidden
          autoFocus
        />
      </div>

      {hasError && (
        <p className="mb-4 text-sm text-[#cb4e4b]">{t('space-passcode-page.invalid')}</p>
      )}

      <ViverseButton type="submit" disabled={passcode.length !== PASSCODE_LENGTH}>
        {t('space-passcode-page.join')}
      </ViverseButton>
    </form>
  )
}
